<!--
/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div>
    <h3 class="apcwo-pr-section">Competency rating</h3>
    <div v-for="c in schema.competencies" :key="c.key" class="apcwo-pr-hr-row">
      <div class="apcwo-pr-hr-row__top">
        <strong>{{ c.label.toUpperCase() }}</strong>
        <rating-input
          v-model="ev.competencies[c.key].rating"
          :readonly="!editable"
        />
      </div>
      <oxd-input-field
        v-model="ev.competencies[c.key].notes"
        type="textarea"
        placeholder="Notes"
        :disabled="!editable"
      />
    </div>

    <h3 class="apcwo-pr-section">Overall employee performance</h3>
    <div v-for="c in schema.overall" :key="c.key" class="apcwo-pr-hr-row">
      <div class="apcwo-pr-hr-row__top">
        <strong>{{ c.label.toUpperCase() }}</strong>
        <rating-input
          v-model="ev.overall[c.key].rating"
          :readonly="!editable"
        />
      </div>
      <oxd-input-field
        v-model="ev.overall[c.key].notes"
        type="textarea"
        placeholder="Notes"
        :disabled="!editable"
      />
    </div>

    <h3 class="apcwo-pr-section">EMPLOYEE POTENTIAL</h3>
    <div class="apcwo-pr-potential">
      <button
        v-for="p in schema.potential"
        :key="p.key"
        type="button"
        :disabled="!editable"
        :class="['apcwo-pr-potential__opt', {'is-on': ev.potential === p.key}]"
        @click="ev.potential = ev.potential === p.key ? null : p.key"
      >
        {{ ev.potential === p.key ? '☒' : '☐' }} {{ p.label.toUpperCase() }}
      </button>
    </div>
    <oxd-input-field
      v-model="ev.potentialComments"
      type="textarea"
      label="Comments"
      :disabled="!editable"
      class="apcwo-pr-field"
    />

    <h3 class="apcwo-pr-section">Goals for the next year</h3>
    <oxd-input-field
      v-model="ev.goals"
      type="textarea"
      :disabled="!editable"
      class="apcwo-pr-field"
    />

    <h3 class="apcwo-pr-section">Overall comments</h3>
    <oxd-input-field
      v-model="ev.overallComments"
      type="textarea"
      :disabled="!editable"
      class="apcwo-pr-field"
    />
    <oxd-grid :cols="2" class="orangehrm-full-width-grid">
      <oxd-grid-item>
        <oxd-input-field
          v-model="ev.reviewerName"
          label="Reviewer name"
          :disabled="!editable"
        />
      </oxd-grid-item>
      <oxd-grid-item>
        <date-input
          v-model="ev.reviewDate"
          label="Review date"
          :disabled="!editable"
        />
      </oxd-grid-item>
    </oxd-grid>
  </div>
</template>

<script>
import RatingInput from './RatingInput.vue';

// Edits the object passed in place (the page's own copy of the data).
export default {
  name: 'EvaluationForm',
  components: {'rating-input': RatingInput},
  props: {
    model: {type: Object, required: true},
    schema: {type: Object, required: true},
    editable: {type: Boolean, default: false},
  },
  data() {
    return {ev: this.model};
  },
};
</script>
